import { Link } from "@/components/shared/link";
import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

import { Typography } from "../../typography";

export function DesktopNavButton({
  title,
  active,
  href,
}: {
  title: string;
  active?: boolean;
  href: string;
}) {
  return (
    <View
      className={cn(
        "hover:bg-brand-static-hover flex flex-col items-center rounded-full border border-transparent py-1",
        {
          "border-brand-static-border bg-brand-over-static": active,
        },
      )}
    >
      <Link href={href}>
        <Typography variant="label-sm" align="center" className="cursor-pointer px-3" color="white">
          {title}
        </Typography>
      </Link>
    </View>
  );
}
